import {
  IconButton,
  InputAdornment,
  OutlinedInput,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import { DeleteOutline, Edit } from "@mui/icons-material";
import { RightOutlined } from "@ant-design/icons";
import axios from "axios";
import defaultt from "../../assets/images/default.png";
import "../Brands/Brands.css";
import { useForm } from "react-hook-form";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Camera from "../../assets/svg/Camera.svg";
import AddPhoto from "../../assets/svg/AddPhoto.svg";
import DeleteModal from "../../components/Modals/DeleteModal";
import NotFound from "../../components/SharedModule/NotFound";
import { useSelector } from "react-redux";

export default function Brands() {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const [addMainCatigory, setAddMainCatigory] = useState({
    logo: "",
    description: "",
    name: "",
    status: "",
    manufacturer_id: "",
    category_ids: [],
  });

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setAddMainCatigory({
      logo: "",
      fileUrl: "",
      name: "",
      description: "",
      status: "",
      manufacturer_id: "",
      category_ids: [],
    });
    setIsEditing(false);
    setEditBrandId(null);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setIsEditing(false);
    setEditBrandId(null);
  };

  const onSubmitAddMainCatogiry = () => {
    const headers = {
      Authorization: "Bearer " + token,
    };

    const formData = new FormData();

    if (isEditing) {
      formData.append("_method", "PATCH");
    }

    if (!isEditing) {
      if (addMainCatigory.logo instanceof File) {
        formData.append("logo", addMainCatigory.logo);
      } else {
        toast.error("Please upload a valid image for the icon.");
        return;
      }
    } else {
      if (addMainCatigory.logo instanceof File) {
        formData.append("logo", addMainCatigory.logo);
      }
    }

    formData.append("name", addMainCatigory.name);
    formData.append("description", addMainCatigory.description);
    formData.append("status", addMainCatigory.status);
    formData.append("manufacturer_id", addMainCatigory.manufacturer_id);
    addMainCatigory.category_ids.forEach((id) => {
      formData.append("category_ids[]", id);
    });

    const url = isEditing
      ? `${newBaseUrl}/api/portal/brands/${editBrandId}`
      : `${newBaseUrl}/api/portal/brands`;

    axios
      .post(url, formData, { headers })
      .then((response) => {
        console.log(response.data);
        toast.success(
          isEditing ? "Brand Updated Successfully" : "Brand Added Successfully",
          { autoClose: 3000 }
        );
        setShow(false);
        setIsEditing(false);
        // setIsSubCategory(false)
        getBrands();
        setAddMainCatigory({
          logo: "",
          description: "",
          name: "",
          status: "",
          manufacturer_id: "",
          category_ids: [],
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const [isEditing, setIsEditing] = useState(false);

  const [editBrandId, setEditBrandId] = useState(null);

  const handleEditBrand = (category) => {
    console.log(category);

    const hasImage = category?.logo_path !== null;

    const fullImageUrl = hasImage
      ? category.logo_path.startsWith("http")
        ? category.logo_path
        : `${newBaseUrl}${category.logo_path}`
      : "";

    const categoryIds = category.categories?.map((cat) => cat.id) || [];

    setAddMainCatigory({
      logo: "",
      fileUrl: fullImageUrl,
      name: category.name,
      description: category.description,
      status: category.status,
      manufacturer_id: category.manufacturer?.id,
      category_ids: categoryIds,
    });
    setValue("name", category.name);
    setValue("description", category.description);
    setValue("status", category.status);
    setValue("manufacturer_id", category.manufacturer?.id);
    setValue("category_ids", categoryIds);
    setIsEditing(true);
    setEditBrandId(category.id);
    setShow(true);
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm();

  const navigate = useNavigate();

  const goToProfile = (id) => {
    navigate(`/Brands/${id}`);
  };

  const [brands, setBrands] = useState([]);

  const [categories, setCategories] = useState([]);

  const [manufacturers, setManufacturers] = useState([]);

  const getManufacturers = async () => {
    try {
      let response = await axios.get(`${newBaseUrl}/api/portal/manufacturers`, {
        headers,
      });
      console.log(response.data.data.manufacturers);
      setManufacturers(response.data.data.manufacturers);
    } catch (error) {
      console.log(error);
    }
  };

  const getBrands = async () => {
    try {
      let response = await axios.get(`${newBaseUrl}/api/portal/brands`, {
        headers,
      });
      console.log(response.data.data);
      setCategories(response.data.data.categories);
      setBrands(response.data.data.brands);
    } catch (error) {
      console.log(error);
    }
  };

  const [showDelete, setShowDelete] = useState(false);

  const handleDeleteClose = () => {
    setShowDelete(false);
    setEditBrandId(null);
    handleClose();
  };

  const confirmDelete = (id) => {
    setShowDelete(true);
    setEditBrandId(id);
  };

  const deleteCategory = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/brands/${editBrandId}`,
        {
          headers,
        }
      );
      toast.warning("Brand Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      getBrands();
    } catch (error) {
      toast.error("Failed To Delete This Brand.");
      console.log(error.message);
    }
  };

  const [searchQuery, setSearchQuery] = useState("");

  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const handleTabChange = (event, newValue) => {
    setSelectedCategoryId(newValue);
  };

  const filteredBrands = useMemo(() => {
    return brands.filter((brand) => {
      const matchesCategory =
        selectedCategoryId === null ||
        brand.categories?.some((cat) => cat.id === selectedCategoryId);

      const matchesSearch = brand.name
        .toLowerCase()
        .includes(searchQuery.toLowerCase());

      return matchesCategory && matchesSearch;
    });
  }, [brands, selectedCategoryId, searchQuery]);

  // const rows = filteredBrands.map((brand) => ({
  //   id: brand.id,
  //   Name: {
  //     name: brand.name,
  //     imageUrl:
  //       brand.logo_path !== null ? `${newBaseUrl}${brand.logo_path}` : defaultt,
  //   },
  //   CategoryImages: brand.categories?.map((cat) => cat.image_url) || [],
  //   Quantity: brand.total_products,
  //   Status: brand.status,
  //   CreatedOn: new Date(brand.created_at).toLocaleDateString(),
  //   Manufacturer: brand.operator?.name || "Unknown",
  //   Actions: "",
  //   rawData: brand,
  // }));

  // const columns = [
  //   { field: "id", headerName: "Brand ID", flex: 0.9, minWidth: 120 },
  //   {
  //     field: "Name",
  //     headerName: "Brand Name",
  //     flex: 0.9,
  //     minWidth: 120,
  //     renderCell: (params) => {
  //       const { name, imageUrl } = params.value;

  //       return (
  //         <div className="d-flex justify-content-center align-items-center h-100">
  //           <img
  //             src={imageUrl}
  //             alt={`${name} logo`}
  //             style={{
  //               width: 20,
  //               height: 20,
  //               objectFit: "cover",
  //             }}
  //           />
  //           <span className="ms-2">{name}</span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     field: "CategoryImages",
  //     headerName: "Categories",
  //     flex: 1,
  //     minWidth: 150,
  //     renderCell: (params) => (
  //       <div className="d-flex justify-content-center align-items-center h-100">
  //         {params.value?.map((url, i) => (
  //           <img
  //             key={i}
  //             src={`${newBaseUrl}${url}`}
  //             alt="category"
  //             style={{
  //               width: 30,
  //               height: 30,
  //               borderRadius: 4,
  //               objectFit: "cover",
  //             }}
  //           />
  //         ))}
  //       </div>
  //     ),
  //   },
  //   {
  //     field: "Quantity",
  //     headerName: "Product No.",
  //     flex: 0.8,
  //     minWidth: 110,
  //   },
  //   { field: "Status", headerName: "Status", flex: 0.8, minWidth: 110 },
  //   { field: "CreatedOn", headerName: "Created On", flex: 1, minWidth: 110 },
  //   {
  //     field: "Manufacturer",
  //     headerName: "Created By",
  //     flex: 1,
  //     minWidth: 110,
  //   },
  //   {
  //     field: "Actions",
  //     headerName: "Actions",
  //     flex: 1,
  //     minWidth: 140,
  //     sortable: false,
  //     filterable: false,
  //     align: "center",
  //     headerAlign: "center",
  //     renderCell: (params) => {
  //       const brand = params.row.rawData;

  //       const handleEdit = (e) => {
  //         e.stopPropagation();
  //         handleEditBrand(brand);
  //       };

  //       const handleDelete = (e) => {
  //         e.stopPropagation();
  //         confirmDelete(params.row.id);
  //       };

  //       const handleNavigate = (e) => {
  //         e.stopPropagation();
  //         goToProfile(params.row.id);
  //       };

  //       return (
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "space-evenly",
  //             alignItems: "center",
  //             height: "100%",
  //             width: "100%",
  //           }}
  //         >
  //           <IconButton
  //             style={{ width: "30%" }}
  //             onClick={handleEdit}
  //             color="default"
  //             size="small"
  //           >
  //             <Edit />
  //           </IconButton>
  //           <IconButton
  //             style={{ width: "30%" }}
  //             onClick={handleDelete}
  //             color="error"
  //             size="small"
  //           >
  //             <DeleteOutline />
  //           </IconButton>
  //           <IconButton
  //             style={{ width: "30%" }}
  //             onClick={handleNavigate}
  //             color="default"
  //             size="small"
  //           >
  //             <RightOutlined />
  //           </IconButton>
  //         </div>
  //       );
  //     },
  //   },
  // ];

  const rows = filteredBrands.map((brand) => ({
    id: brand.id,
    ref:brand.reference,
    Name: {
      name: brand.name,
      imageUrl:
        brand.logo_path !== null ? `${newBaseUrl}${brand.logo_path}` : defaultt,
    },
    CategoryImages: brand.categories?.map((cat) => cat.image_url) || [],
    Quantity: brand.total_variations,
    Status: brand.status,
    CreatedOn: new Date(brand.created_at).toLocaleDateString(),
    CreatedBy: brand.operator?.name || "Unknown",
    Manufacturer: brand.manufacturer?.name || "Unknown",
    Actions: "",
    rawData: brand,
  }));

  const columns = [
    {
      field: "ref",
      headerName: "Reference",
      flex: 1.4,
      minWidth: 200,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
            textAlign: "center",
            lineHeight: "18px",
            fontWeight: 600,
          }}
        >
          {params.row.ref || "-"}
        </div>
      ),
    },
    {
      field: "Name",
      headerName: "Brand Name",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => {
        const { name, imageUrl } = params.value;

        return (
          <div className="d-flex justify-content-center align-items-center h-100">
            <img
              src={imageUrl}
              alt={`${name} logo`}
              style={{
                width: 20,
                height: 20,
                objectFit: "cover",
              }}
            />
            <span className="ms-2">{name}</span>
          </div>
        );
      },
    },
    {
      field: "CategoryImages",
      headerName: "Categories",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <div className="d-flex justify-content-center align-items-center h-100">
          {params.value?.map((url, i) => (
            <img
              key={i}
              src={`${newBaseUrl}${url}`}
              alt="category"
              style={{
                width: 30,
                height: 30,
                borderRadius: 4,
                objectFit: "cover",
              }}
            />
          ))}
        </div>
      ),
    },
    {
      field: "Quantity",
      headerName: "Product No.",
      flex: 0.8,
      minWidth: 110,
    },
    { field: "Status", headerName: "Status", flex: 0.8, minWidth: 110 },
    { field: "CreatedOn", headerName: "Created On", flex: 1, minWidth: 110 },
    {
      field: "Manufacturer",
      headerName: "Manufacturer",
      flex: 1,
      minWidth: 110,
    },
    {
      field: "CreatedBy",
      headerName: "Created By",
      flex: 1,
      minWidth: 110,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 140,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const brand = params.row.rawData;

        const handleEdit = (e) => {
          e.stopPropagation();
          handleEditBrand(brand);
        };

        const handleDelete = (e) => {
          e.stopPropagation();
          confirmDelete(params.row.id);
        };

        const handleNavigate = (e) => {
          e.stopPropagation();
          goToProfile(params.row.id);
        };

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              style={{ width: "30%" }}
              onClick={handleEdit}
              color="default"
              size="small"
            >
              <Edit />
            </IconButton>
            <IconButton
              style={{ width: "30%" }}
              onClick={handleDelete}
              color="error"
              size="small"
            >
              <DeleteOutline />
            </IconButton>
            <IconButton
              style={{ width: "30%" }}
              onClick={handleNavigate}
              color="default"
              size="small"
            >
              <RightOutlined />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  useEffect(() => {
    getBrands();
    getManufacturers();
  }, []);

  return (
    <>
      {/* delete brand  */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this brand?"}
        deleteFunction={deleteCategory}
      />
      {/* add brand modal  */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isEditing ? "Edit Brand" : "Add Brand"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddMainCatogiry)}>
            {/* image  */}
            <div className="flex-center-x-y">
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                {...register("logo")}
                id="icon_url"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    const allowedTypes = [
                      "image/jpeg",
                      "image/png",
                      "image/jpg",
                      "image/gif",
                      "image/svg+xml",
                    ];
                    if (allowedTypes.includes(file.type)) {
                      const imageUrl = URL.createObjectURL(file);
                      setAddMainCatigory({
                        ...addMainCatigory,
                        logo: file,
                        fileUrl: imageUrl,
                      });
                    } else {
                      toast.error(
                        "Please select a valid image file (jpeg, png, jpg, gif, svg)."
                      );
                      setAddMainCatigory({
                        ...addMainCatigory,
                        logo: "",
                        fileUrl: "",
                      });
                    }
                  }
                }}
              />
              <label htmlFor="icon_url" className="categories_photo">
                <img
                  className="categories-add "
                  src={addMainCatigory.fileUrl || AddPhoto}
                  alt="Selected"
                />
                <div className="categories_cameraIcon">
                  <img src={Camera} alt="Camera Icon" />
                </div>
              </label>
              {errors.logo && <p className="danger">{errors.logo.message}</p>}
            </div>
            {/* name */}
            <div className="row">
              <div className="col-12">
                <TextField
                  className="w-100 mb-3"
                  label="Brand Name"
                  variant="outlined"
                  {...register("name")}
                  value={addMainCatigory.name}
                  onChange={(e) => {
                    setAddMainCatigory({
                      ...addMainCatigory,
                      name: e.target.value,
                    });
                  }}
                />
                {errors.name && <p className="danger">{errors.name.message}</p>}
              </div>
            </div>
            {/* description  */}
            <TextField
              className="w-100 mb-3"
              label="Brand Description"
              variant="outlined"
              rows={4}
              multiline
              {...register("description")}
              value={addMainCatigory.description}
              onChange={(e) => {
                setAddMainCatigory({
                  ...addMainCatigory,
                  description: e.target.value,
                });
              }}
            />
            {errors.description && (
              <p className="danger">{errors.description.message}</p>
            )}
            {/* category & Manufacturer */}
            <div className="row">
              {/* category  */}
              <div className="col-6">
                <FormControl className="w-100 mb-3" variant="outlined">
                  <InputLabel id="status-label">Category</InputLabel>
                  <Select
                    labelId="Category-label"
                    label="Category"
                    multiple
                    {...register("category_ids")}
                    value={addMainCatigory.category_ids}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        category_ids: e.target.value,
                      });
                      setValue("category_ids", e.target.value);
                    }}
                    renderValue={(selected) =>
                      categories
                        .filter((cat) => selected.includes(cat.id))
                        .map((cat) => cat.name)
                        .join(", ")
                    }
                  >
                    {categories.map((cat) => (
                      <MenuItem
                        className="custom-menu-item"
                        key={cat.id}
                        value={cat.id}
                      >
                        {cat.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.category_ids && (
                  <p className="danger">{errors.category_ids.message}</p>
                )}
              </div>
              {/* Manufacturer  */}
              <div className="col-6">
                <FormControl className="w-100 mb-3" variant="outlined">
                  <InputLabel id="Manufacturer-label">Manufacturer</InputLabel>
                  <Select
                    labelId="Manufacturer-label"
                    label="Manufacturer"
                    {...register("manufacturer_id")}
                    value={addMainCatigory.manufacturer_id}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        manufacturer_id: e.target.value,
                      });
                    }}
                  >
                    {manufacturers.map((manf) => (
                      <MenuItem className="custom-menu-item" value={manf.id}>
                        {manf.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.manufacturer_id && (
                  <p className="danger">{errors.manufacturer_id.message}</p>
                )}
              </div>
            </div>
            {/* status  */}
            <div className="row">
              <div className="col-12">
                <FormControl className="w-100 mb-3" variant="outlined">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    label="Status"
                    {...register("status")}
                    value={addMainCatigory.status}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        status: e.target.value,
                      });
                    }}
                  >
                    <MenuItem className="custom-menu-item" value="active">
                      Active
                    </MenuItem>
                    <MenuItem className="custom-menu-item" value="inactive">
                      Inactive
                    </MenuItem>
                  </Select>
                </FormControl>
                {errors.status && (
                  <p className="danger">{errors.status.message}</p>
                )}
              </div>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <div className="mx-4 my-3">
        {/* stock header */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
          <h5 className="fw-bold mb-0">Brands</h5>
          <button
            onClick={handleShow}
            className="btn btn-outline-secondary d-flex align-items-center"
            style={{ height: "38px" }}
          >
            <i className="fa-solid fa-plus me-2"></i> Add New Brand
          </button>
        </div>
        {/* stock search */}
        <div className="row d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-3 my-0">
          {/* tabs */}
          <div className="col-6">
            <div
              className="bg-light rounded-3 d-flex align-items-center mb-3"
              style={{
                width: "100%",
                overflowX: "auto",
                WebkitOverflowScrolling: "touch",
                height: "40px",
              }}
            >
              <Tabs
                value={selectedCategoryId}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                aria-label="brand category tabs"
                sx={{
                  minHeight: "40px",
                  height: "40px",
                }}
                slotProps={{
                  indicator: {
                    sx: { backgroundColor: "transparent" },
                  },
                }}
              >
                <Tab
                  key="all"
                  label={
                    <span className="tab-label">
                      All <span className="circle">{brands.length}</span>
                    </span>
                  }
                  value={null}
                  sx={{
                    minHeight: "40px",
                    height: "40px",
                  }}
                />
                {categories.map((category) => (
                  <Tab
                    key={category.id}
                    label={
                      <span className="tab-label">
                        {category.name}
                        <span className="circle">{category.brands_count}</span>
                      </span>
                    }
                    value={category.id}
                    sx={{
                      minHeight: "40px",
                      height: "40px",
                    }}
                  />
                ))}
              </Tabs>
            </div>
          </div>
          {/* search */}
          <div className="col-3">
            <div className="w-100">
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel htmlFor="search-brands">
                  Search for Brand Name...
                </InputLabel>
                <OutlinedInput
                  id="search-brands"
                  type="text"
                  size="small"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  label="Search for Brand Name..."
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton edge="end">
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
          </div>
        </div>
        {/* stock data */}
        <div>
          {filteredBrands && filteredBrands.length > 0 ? (
            <div className="scrollable-table-wrapper">
              <div>
                <Paper sx={{ width: "100%" }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5, 10]}
                    checkboxSelection
                    sx={{ border: 0 }}
                    slotProps={{
                      pagination: {
                        sx: {
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                      },
                    }}
                  />
                </Paper>
              </div>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ minHeight: "300px" }}
            >
              <NotFound
                paragraphText={
                  "No Brands Yet. All your Brands will appear here once you get started."
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
